// extracted by mini-css-extract-plugin
export var brand = "_24-9";
export var compact = "_24-6";
export var extraSmall = "_24-7";
export var icon = "_24-0";
export var large = "_24-4";
export var light = "_24-1";
export var medium = "_24-5";
export var outline = "_24-b";
export var primaryDark = "_24-a";
export var primaryLight = "_24-8";
export var primaryModern = "_24-c";
export var success = "_24-2";
export var successSolid = "_24-3";